import React from 'react'
import { Box, Flex, Text, Heading } from '@moonpig/launchpad-components'
import { css, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { theme } from '@moonpig/launchpad-theme'
import { IconSystemPlus } from '@moonpig/launchpad-assets'
import { useFindLocaleText } from '../../../text-localisation'

const Graphic = styled.div`
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${s({
    bgcolor: 'colorBlack05',
    width: { xs: '124px', md: '148px' },
    height: { xs: '124px', md: '148px' },
  })}
`

const placeholderCardStyles = css`
  ${s({ bgcolor: 'colorBlack10' })}
  box-shadow: 0 0 0 3px ${theme.colors.colorBackground01};
`

const CardStack = styled.div`
  position: absolute;
  top: 33%;
  left: 20%;
  ${s({
    width: { xs: '61px', md: '73px' },
    height: { xs: '89px', md: '106px' },
  })}
  isolation: isolate;

  &::before,
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    ${placeholderCardStyles}
    transform-origin: left bottom;
  }

  &::before {
    z-index: 0;
    transform: rotate(24deg);
  }

  &::after {
    z-index: 1;
    transform: rotate(12deg);
  }
`

const FrontCard = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${placeholderCardStyles}
`

const IconContainer = styled.div`
  display: flex;
  ${s({
    alignItems: 'center',
    justifyContent: 'center',
    color: 'colorInteractionSelectedState',
    bgcolor: 'colorBackground01',
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    boxShadow: 2,
    position: 'absolute',
    top: '39%',
  })}
`

export const EmptyState = () => {
  const localiseText = useFindLocaleText()
  return (
    <Flex
      data-testid="shopping-list-empty-state"
      aria-label={localiseText('find.shopping_list_add_item')}
      width="100%"
      alignItems="center"
      justifyContent="center"
      flexDirection={{ xs: 'column', md: 'row' }}
    >
      <Graphic data-testid="shopping-list-placeholder-item" aria-hidden>
        <CardStack>
          <FrontCard>
            <IconContainer>
              <IconSystemPlus width="20px" height="20px" />
            </IconContainer>
          </FrontCard>
        </CardStack>
      </Graphic>
      <Box m={6} textAlign={{ xs: 'center', md: 'left' }}>
        <Heading level="h4" margin="0" typography="typeMobileDisplay05">
          {localiseText('find.shopping_list.empty_state.no_cards_added')}
        </Heading>
        <Text color="colorBlack60">
          {localiseText('find.shopping_list.empty_state.subheading')}
        </Text>
      </Box>
    </Flex>
  )
}
